import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { Auth } from 'aws-amplify';
import { ICredentials } from 'aws-amplify/lib/Common/types/types';
import { decodeJwt } from 'jose';

export type AuthFlowType = 'signup' | 'login';

export const canChangeCognitoCredentials = (
  idToken?: string | null,
): boolean => {
  if (!idToken) {
    return false;
  }

  try {
    const payload = decodeJwt(idToken);

    return !payload.identities;
  } catch {
    return false;
  }
};

type SocialAuthOptions = {
  flow?: AuthFlowType;
};

export const SIGNUP_PATH = '/signup';

export const getAuthFlowFromPath = (pathname: string): AuthFlowType =>
  pathname === SIGNUP_PATH ? 'signup' : 'login';

const buildCustomState = (provider: string, flow: AuthFlowType) =>
  `flow=${flow}&provider=${provider}`;

export const logInGoogle = (
  options: SocialAuthOptions = {},
): Promise<ICredentials> => {
  const flow: AuthFlowType = options.flow || 'login';

  return Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
    customState: buildCustomState('google', flow),
  });
};

export const logInFacebook = (
  options: SocialAuthOptions = {},
): Promise<ICredentials> => {
  const flow: AuthFlowType = options.flow || 'login';

  return Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Facebook,
    customState: buildCustomState('facebook', flow),
  });
};

export const logInApple = (
  options: SocialAuthOptions = {},
): Promise<ICredentials> => {
  const flow: AuthFlowType = options.flow || 'login';

  return Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Apple,
    customState: buildCustomState('apple', flow),
  });
};

export const getLinkParams = (
  link: string,
): {
  code: string;
  userName: string;
} => {
  const search = new URLSearchParams(link);
  const code = search.get('c');
  const userName = search.get('u');

  return {
    code,
    userName,
  };
};
